const userRoles = {
    INDIVIDUAL: "individual",
    FIRM: "firm",
    STAFF: "staff",
    ADMINISTRATOR: "administrator",
    BOARD: "board"
}

export default {
    userRoles
}